/**
 * Demo-scoped card thumbnail overrides.
 *
 * `EducationContent` carries a single image (`image_path` → one `imageUrl`),
 * which both the article hero and the carousel card read. The hero is a ~900×600
 * landscape; the card's thumbnail slot is 105×244 portrait and paints it with
 * `background-size: cover`, so ~71% of the width is cropped away and the subject
 * falls out of frame.
 *
 * Until the content pipeline emits a purpose-framed crop per surface (a real
 * `thumbnail_path` alongside `image_path`), these hand-exported 105×244 covers
 * stand in for the Hadassah articles on the card only — the article page keeps
 * rendering the full-width hero from S3.
 *
 * The values are CSS-module class names, not URLs: the asset paths live in
 * `ContentCard.module.css` so this override doesn't add an inline style. Any
 * name added here needs a matching class in that file.
 *
 * Delete this module (and those classes) once `thumbnail_path` lands;
 * `getCardThumbnailClass` returning null is the normal path for every other
 * article.
 */
const CARD_THUMBNAIL_CLASSES: Record<string, string> = {
	// מידע כללי — לקראת שימור הפריון
	"0a4e6b2c-9d3f-4c1a-8e5b-2f7d1c3a9e01": "hadassahCover1",
	// לפני הטיפול — כל מה שכדאי לדעת
	"0a4e6b2c-9d3f-4c1a-8e5b-2f7d1c3a9e02": "hadassahCover2",
	// לקראת שאיבת הביציות
	"0a4e6b2c-9d3f-4c1a-8e5b-2f7d1c3a9e03": "hadassahCover3",
	// אחרי שאיבת הביציות
	"0a4e6b2c-9d3f-4c1a-8e5b-2f7d1c3a9e04": "hadassahCover4",
};

/**
 * The `ContentCard.module.css` class carrying this article's purpose-framed
 * thumbnail, or null when the card should fall back to the article's own hero.
 */
export function getCardThumbnailClass(contentId: string): string | null {
	return CARD_THUMBNAIL_CLASSES[contentId] ?? null;
}
